export default __webpack_public_path__ + "static/media/people9full.58ee7cec.jpg";